<template>
  <v-container class="width50">
    <v-row>
      <v-col cols="12" class="font25 center">
        {{$t('yourServices')}}
      </v-col>
    </v-row>

    <div v-for="(batch, index) in batches" v-bind:key="index">

        <v-row>
          <v-col cols="12" class="font25">
            {{ batch.main_account.address.line1 }} {{ batch.main_account.address.line2 }} {{ batch.main_account.address.fiberhood_name }} {{ (batch.main_account.address.city_name ? batch.main_account.address.city_name + ',' : '') }} {{ batch.main_account.address.zipcode }}
          </v-col>
        </v-row>


        <div v-for="account in batch.accounts" v-bind:key="account.id">
            <v-row>
              <v-col
              cols="12"
              sm="12"
              >
                 <subscription-info
                v-bind:account="account"
                @loading="loading"
                @error-message="showError"
                />
              </v-col>
            </v-row>
        </div>

        <v-row v-if="batch.accounts.some(account => account.id.startsWith('1787'))">
          <v-col
          cols="12"
          sm="12"
          >
            <voice-calls-table
            v-bind:phoneService="batch.accounts.filter(account => account.id.startsWith('1787'))"
            @loading="loading"
            @error-message="showError"
            />
          </v-col>
        </v-row>



    </div>
  </v-container>
</template>

<script>
// importing child components
import SubscriptionInfo from '@/components/Services/Other/SubscriptionInfoCard.vue';
import VoiceCallsTable from '../../components/Services/Phone/VoiceCallsTable.vue';

export default {
  name: 'phone-',
  // child components that are being displayed
  components: {
    SubscriptionInfo,
    VoiceCallsTable,
  },
  // data received from parent component
  props: ['batches'],
  methods: {
    // showing error message with message received
    showError(msg){
      this.$emit('error-message', msg);
    },
    // setting loading component to true or false, depending
    // in what's received
    loading(val) {
      this.$emit('loading', val);
    }
  },
  computed: {
      isOpen: {
          get () {
              return this.showDialog
          },
          set (value) {
              this.$emit('input', value)
          }
      },
  },
}
</script>
